// Thin wrapper around the GA4 gtag() call wired up in app/layout.tsx.
// Safe to call from anywhere on the client — no-ops during SSR or if the
// GA script hasn't loaded yet.
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackEvent(
  eventName: string,
  params?: Record<string, unknown>,
) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }
  window.gtag("event", eventName, params);
}
